import Vue from 'vue'
import Login from './Login.vue'
import store from './store/login'
import ElementUI from 'element-ui';
import axios from './config/axios.config'
import VueCookie from 'vue-cookie'
import router from './router/login'
import filter from "./filter";

Vue.config.productionTip = false;
Vue.prototype.axios = axios;


Vue.use(ElementUI);
Vue.use(VueCookie);
Vue.use(filter);


new Vue({
  router,
  store,
  render: h => h(Login)
}).$mount('#app');
